import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/proxy/hotels', request)
}

async function getFull(request) {
    return await getMethod('/api/hotels', request)
}

export {get, getFull}
